export enum DocumentTypeEnum {
  SinDocumento = 6
}
